import { render, staticRenderFns } from "./CompetitionDetailMainSlideLayout.vue?vue&type=template&id=4f0a325d&scoped=true"
import script from "./CompetitionDetailMainSlideLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailMainSlideLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a325d",
  null
  
)

export default component.exports